import React from 'react'
import { CFView, CFImage, DefaultScreen, MobileScreen } from 'components'
import { mobilePromotion, promotions } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView column mv="30px" center>
          <CFImage src={mobilePromotion} w="90%" alt="Promotions" />
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView column center m="50px auto" w="100%">
          <CFImage src={promotions} alt="Promotions" w="80%" />
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
